/**
 * The single seam between QuotyLab and where its data lives.
 *
 * Deliberately async even though `localStorage` is synchronous: swapping in
 * Supabase, Firebase or an HTTP API later becomes a one-line change in
 * `StorageProvider` rather than a refactor of every call site.
 */
export interface StorageAdapter {
  read<T>(key: string): Promise<T | null>;
  write<T>(key: string, value: T): Promise<void>;
  remove(key: string): Promise<void>;
  keys(): Promise<string[]>;
}

export class StorageError extends Error {
  readonly detail: unknown;

  constructor(message: string, detail?: unknown) {
    super(message);
    this.name = 'StorageError';
    this.detail = detail;
  }
}
